// extracted by mini-css-extract-plugin
export default {"productGallery":"pH-z","inQuickShop":"qH-z"};